module.exports = __webpack_public_path__ + "notfound-icon-114affdc.png";